export default __webpack_public_path__ + "static/media/arihant_black_logo.dad2ad4c.png";